export default "__VITE_ASSET__BSVnvFu8__"